let is_login = false;
let mb_idx = null;
let mb_id = null;
let mb_name = null;
let mb_nick = null;
let mb_level = null; 
let mb_boss_id = null;
let mb_staff = null;
let acc_type = null;
let mb_grade = null;


if (safeGetItem('token') || safeGetItem('admin_token')) {
	setUserInfo({
		mb_idx: safeGetItem('mb_idx'),
		mb_id: safeGetItem('mb_id'),
		mb_name: safeGetItem('mb_name'),
		mb_nick: safeGetItem('mb_nick'),
		mb_level: safeGetItem('mb_level') ?? 0,
		mb_boss_id: safeGetItem('mb_boss_id'),
		mb_staff: safeGetItem('mb_staff'),
		acc_type: safeGetItem('acc_type'),
		mb_grade: safeGetItem('mb_grade'),
	});
}

// 로그인 후 토큰 설정 함수
function setAuthToken(token) {
	axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// 로그인 상태 설정 함수
function setLogin(status) {
	is_login = status;
}

function getIsLogin() {
	return is_login;
}

// 사용자 정보 설정 함수
function setUserInfo(userInfo) {
	mb_idx = userInfo.mb_idx;
	mb_id = userInfo.mb_id;
	mb_name = userInfo.mb_name;
	mb_nick = userInfo.mb_nick;
	mb_level = userInfo.mb_level ?? 0;
	mb_boss_id = userInfo.mb_boss_id;
	mb_staff = userInfo.mb_staff;
	acc_type = userInfo.acc_type;
	mb_grade = userInfo.mb_grade;

	// 250522_JAMONG removeItem 추가, setLogin 추가
	safeSetItem('mb_idx', mb_idx);
	safeSetItem('mb_id', mb_id);
	safeSetItem('mb_name', mb_name);
	safeSetItem('mb_nick', mb_nick);
	safeSetItem('mb_level', Number(mb_level));
	safeSetItem('mb_boss_id', mb_boss_id);
	safeSetItem('mb_staff', mb_staff);
	safeSetItem('acc_type', acc_type);
	safeSetItem('mb_grade', mb_grade);

	setLogin(true);
}


// 사용자 정보 초기화 함수
function clearUserInfo() {
	mb_idx = null;
	mb_id = null;
	mb_name = null;
	mb_nick = null;
	mb_level = null;
	mb_boss_id = null;
	mb_staff = null;
	acc_type = null;
	mb_grade = null;

	// 250522_JAMONG removeItem 추가, setLogin 추가
	localStorage.removeItem('mb_idx');
	localStorage.removeItem('mb_id');
	localStorage.removeItem('mb_name');
	localStorage.removeItem('mb_nick');
	localStorage.removeItem('mb_level');
	localStorage.removeItem('mb_boss_id');
	localStorage.removeItem('mb_staff');
	localStorage.removeItem('acc_type');
	localStorage.removeItem('mb_grade');
	localStorage.removeItem('token');
	localStorage.removeItem('admin_token');

	// Authorization 헤더 제거
	if (typeof window !== 'undefined' && window.axios && window.axios.defaults) {
		delete window.axios.defaults.headers.common['Authorization'];
	}

	setLogin(false);
}

function safeSetItem(key, value) {
	try {
		localStorage.setItem(key, JSON.stringify(value));
	} catch (e) {
		console.error(`🔴 safeSetItem 실패: ${key}`, e);
	}
}

function safeGetItem(key) {
	try {
		const val = localStorage.getItem(key);
		return val !== null ? JSON.parse(val) : null;
	} catch (e) {
		console.warn(`🟡 safeGetItem JSON 파싱 실패: ${key}`, e);
		return null;
	}
}

export { is_login, mb_idx, mb_id, mb_name, mb_nick, mb_level, mb_boss_id, mb_staff, acc_type, mb_grade, setAuthToken, setLogin, getIsLogin, setUserInfo, clearUserInfo, safeSetItem, safeGetItem };